export const fridgeData = [
    {    
    name: "The People's Fridge",
    address: "511 s. 52nd Street, Philadelphia, PA 19143",
    mission_1: "Our vision is to provide community members with groceries and pantry items as a free resource. On one level, The People’s Fridge is a way to combat hunger in underserved communities during a pandemic and an economic crisis. We believe that food is a human right and should never be a privilege, but it is. This community fridge is a mutual aid, meaning, community members have equal responsibility filling, maintaining, and caring for it lovingly. Our fridge runs on a ‘take what you need, leave what you can’ basis. There is no pre-screening to take or leave something from the fridge. Part of our purpose is to create a resource people can fall back on, trust, and rely on to be there without repercussions.",
    mission_2: "The People's Fridge was inspired by the recent passing of our father. Because our father passed due to COVID19, we didn't have a way to say goodbye. For us, the fridge is a way to memorialize his lifelong commitment to feeding people. Our mom and dad instilled the ideals of food justice within us, even though they have never come across the term before. Our father modeled mutual aid for us consistently. Him and my mom really loved organizing diaper and formula drops, meal shares. It could be because our family has extremely benefitted from that kind of community aid, growing up in Brooklyn.",
    link:"/thepeoplesfridge",
    class_name: "peoples"
    },

    {
    name: "Germantown Community Fridge",
    address: "20 W Armat Street Philadelphia, PA 19144 ",
    mission_1: "Germantown Community Fridge is a 24/7 community run refrigerator that provides free food & essentials! Anyone is welcome to donate both perishables and non-perishables. We hope to help alleviate food insecurity and fight food waste!",
    link: "/germantowncommunityfridge",
    class_name:"germantown"
    },

    {
    name: "Philadelphia Community Fridge",
    address: "1229 S 6th Street (Radiance Medical Group) & 1901 S 9th Street (BOK)",
    mission_1: "We're a community-centered, volunteer-based organization dedicated to giving all Philadelphians access to fresh and healthy food, combatting food insecurity and inequality in our city through mutual aid. Studies show that nearly 1 in 5 Philadelphia families struggle with hunger, and food pantries' demand for fresh produce has increased 3x since 2019.",
    mission_2: "We partner with local grocers and restaurants to stock this fridge with perfectly good produce, pantry staples, and prepared foods that would otherwise be thrown out. BEING ABLE TO FEED YOURSELF AND YOUR FAMILY ISN'T A PRIVILEGE — IT'S A BASIC HUMAN RIGHT.",
    link:"/philadelphiacommunityfridge",
    class_name:'phillycomm'
    },
     {
    name: "Mama-Tee Community Fridge",
    address: "Many locations",
    addresses:["Spot Burgers:  2821 W. Girard Ave (Brewerytown)",
    "Triple Bottom Brewing:  915 Spring Garden St. (West Poplar)",
    "312 39th Street (West Philly)",
    "Castellino's Italian Market:  1255 E. Palmer (Fishtown)",
    "Ambassador:  635 W. Girard Ave (North Philly/Fishtown)",
    "Franny Lou's Porch:  2400 Coral Street (Kensington)",
    "Caribe Towers:  3231 North 2nd Street (Fairhill)",
    "Opportunity Towers I & II:  1717 W. Hunting Park Ave (Nicetown)",
    "Restoration Church:  6410 Rising Sun Ave. (North East Philly)"
    ],
    ex_link:"https://www.mama-tee.com/communityfridge",
    class_name:'mama-tee'
    }

]